// extracted by mini-css-extract-plugin
export var ads = "styles-module--ads--bdb7b";
export var content_wrapper = "styles-module--content_wrapper--e7cf9";
export var first_post = "styles-module--first_post--c9d36";
export var fourth_post = "styles-module--fourth_post--6548f";
export var posts = "styles-module--posts--1a142";
export var second_post = "styles-module--second_post--78fce";
export var sixth_post = "styles-module--sixth_post--e1a75";
export var verticalAd = "styles-module--verticalAd--6e4a8";
export var wrapper = "styles-module--wrapper--1a8e5";